import { render, staticRenderFns } from "./Technique.vue?vue&type=template&id=15e7fda1&scoped=true&"
import script from "./Technique.vue?vue&type=script&lang=js&"
export * from "./Technique.vue?vue&type=script&lang=js&"
import style0 from "./Technique.vue?vue&type=style&index=0&id=15e7fda1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e7fda1",
  null
  
)

export default component.exports